module.exports = __webpack_public_path__ + "static/media/doctorsectionbg.d8f69011.jpg";